import { useEffect } from "react";
import { useStore } from "../store";
import { fetchAnimes } from "../info";
import { ItemContainer } from "./ItemContainer";
import { AnimeItem } from "./AnimeItem";

export function AnimeItems() {
  const { animes, viewHiddenAnimes } = useStore();

  useEffect(() => {
    fetchAnimes()
  }, []);

  return (<>
    <ItemContainer>
      {
        animes.filter(a => viewHiddenAnimes || !a.deleted)
          .map((a, i) => <AnimeItem key={ a.id } index={ i } anime={ a }/>)
      }
    </ItemContainer>
  </>);
}
